import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  Box,
} from "@mui/material";
import { useSessionTimeout } from "./sessionTimeout";

const SessionTimeoutWrapper = ({ children, onLogout, isActive }) => {
  const { showWarning, resetTimeout } = useSessionTimeout(onLogout, isActive);

  return (
    <>
      {children}
      <Dialog
        open={showWarning && isActive}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"Session Expiring Soon"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Your session will expire soon due to inactivity.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Box sx={{ m: 1 }}>
            <Button
              onClick={resetTimeout}
              variant="contained"
              color="primary"
              //   autoFocus
            >
              Keep Session Active
            </Button>
          </Box>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default SessionTimeoutWrapper;
